<template>
	<div class="container">
		<div class="col-md-12">
			<h2> {{ labels.title }} </h2>
		</div>
		<b-container>
			<!-- Filtros principales - Centrados -->
			<b-row class="mb-4 justify-content-center mt-5">
				<!-- Reporte -->
				<b-col md="4">
					<label class="d-block fw-bold" style="font-size: 1.3rem;"><b>Cod.Reporte:</b></label>
					<select v-model="dialogReportes" class="form-control form-control-lg" @change="f_carga_informacion">
						<option value="">{{ labels.select }}</option>
						<option v-for="(item, idx) in reportes" :key="'codigo-' + idx" :value="item.codigo">
							{{ item.codigo }}-{{ item.nombre }}
						</option>
					</select>
				</b-col>

				<!-- Vigencia -->
				<b-col md="4">
					<label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.validity }}</b></label>
					<select v-model="selVigencia" class="form-control form-control-lg" @change="f_carga_informacion">
						<option value="">{{ labels.select }}</option>
						<option v-for="vigencia in listVigencia" :key="vigencia.vigencia">
							{{ vigencia.vigencia }}
						</option>
					</select>
				</b-col>

			</b-row>
		</b-container>
		<div v-if="selVigencia && dialogReportes">
                <!-- Tabla -->
                <b-row class="mb-3 justify-content-center">
                    <b-col md="12">
                        <div class="table-responsive custom-scroll-container" ref="scrollContainer">
                            <table class="table table-hover table-bordered">
                                <thead style="background-color: #4a90e2;">
                                    <tr>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">{{
                                            labels.niif }}</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">{{
                                            labels.nameNiif }}</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">{{
                                            labels.nota }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="planCons in listNiif" :key="planCons.id"
                                        @click="editaNiif(planCons)" class="clickable-row">
                                        <td class="text-center"><strong class="text-dark">{{ planCons.niif }}</strong>
                                        </td>
                                        <td class="text-left">{{ planCons.descripcion }}</td>
                                        <td class="text-left">
					<select v-model="planCons.nota" class="form-control form-control-lg">
						<option value="">{{ labels.select }}</option>
						<option v-for="(item, idx) in listNotas" :key="'codigo-' + idx" :value="item.numero">
							{{item.numero}}-{{ item.descripcion }}
						</option>
					</select>
					</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-col>
                </b-row>
		</div>
	</div>
</template>

<script>
import Notas from '../../../services/Notas';
import PlanCuentas from '../../../services/PlanCuentas';
import Balance from '../../../services/BalanceNiif'

export default {
	name: 'Notas',
	data: () => ({
		isLoading: false,
		selVigencia: '',
		selReporte: '',
		reportes: [],
		dialogReportes: '',
		listVigencia: [],
		listNotas: [],
		listNiif: [],
	}),
	computed: {
		labels() {
			if (this.$store.state._language == "es-ES") {
				return {
					title: 'Notas Estados Financieros',
					validity: 'Vigencia:',
					select: 'Seleccione...',
					nota: 'Nota',
					niif: 'Niif',
					nameNiif: 'Descripcion',
				}
			} else {
				return {
					title: 'Notes',
					validity: 'Validity',
					select: 'Select...',
					nota: 'Note',
					niif: 'Niif',
					nameNiif: 'Description',

				}
			}
		}
	},
	methods: {
		editaNiif(r_niifNotas) {
console.log(r_niifNotas)
			Notas.grabeNiifNota(r_niifNotas.id,r_niifNotas.nota,this.$store.state.userId)
			.then((res) => {
				this.$toast.success(res.data.message)
			})
			.catch((err) => console.log(err))
		},
		f_carga_informacion() {

			this.listNotas = [];
			this.listNiif = [];

			if	(this.dialogReportes && this.selVigencia) {
				Notas.getAllNotas(this.dialogReportes)
				.then((res) => {
					this.listNotas = res.data.listNotas;
				})
				.catch((err) => {
					console.log(err);
					this.listNotas = [];
				});
			}
			Notas.leaNiifNotas(this.selVigencia, this.dialogReportes)
			.then((res) => {
				this.listNiif = res.data.listNiif || [];
			})
			.catch((error) => {
				console.error('Error al cargar NIIF:', error);
				this.listNiif = [];
			});

		},
		f_titulo() {
			let titulo = ""
			if (this.$store.state._language == "es-ES") {
				titulo = "NOTAS ESTADOS FINANCIEROS"
			} else {
				titulo = "FINANCIAL STATEMENT NOTES"
			}
			titulo = titulo + " " + this.nota
			return titulo

		},
	},
	mounted() {
		Balance.getReportes()
			.then((result) => {
				this.reportes = Array.isArray(result.data.reportes)
					? result.data.reportes
					: (result.data.reportes[0] || []);

			})
			.catch(() => {
				this.error = true;
		});
		PlanCuentas.getVigenciaPlancuentas()
		.then((res) => {
			this.listVigencia = res.data.getVigencia
		})
		.catch((err) => {
			console.log(err)
		})
		.finally(() => {
			this.isLoading = false;
		})
	},
}
</script>
